import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ParticipantGate.css'

function getSessionToken() {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem('study_session_token') || null;
}


function ParticipantGate(){
    const { search, pathname, key } = useLocation();
    const navigate = useNavigate();
    //"query" parses the current URL's query string
    const query = new URLSearchParams(search);
    const modeParam = query.get('mode') || query.get('interface');

    // const [pid, setPid] = useState(''); //Commented for Mturk
    // const [scenario, setScenario] = useState(localStorage.getItem('scenario') || 'human-only');
    const [error, setError] = useState('');
    const location = useLocation();
    const pidRef = useRef(null);

    //for Mturk parameters
    const sp = new URLSearchParams(window.location.search);
    const workerId =
        sp.get('workerId') ||
        sp.get('worker_id') ||
        '';

    const assignmentId =
        sp.get('assignmentId') ||
        sp.get('assignment_id') ||
        '';

    const hitId =
        sp.get('hitId') ||
        sp.get('hit_id') ||
        '';

    const turkSubmitTo =
        sp.get('turkSubmitTo') ||
        sp.get('turk_submit_to') ||
        '';
    const [pid, setPid] = useState(workerId || '');
    const isAnnotate = modeParam === 'annotate';
    const [showPidForm, setShowPidForm] = useState(false);
    const isMTurk      = Boolean(workerId || assignmentId); // AMT visit?
    const isPreview    = assignmentId === 'ASSIGNMENT_ID_NOT_AVAILABLE';

    //commented to handle csv data
    // Reset PID every time this page is opened and focus the input
    // useEffect(() => {
    //     setPid('');
    //     setScenario('human-only');
    //     if (pidRef.current) pidRef.current.focus();
    // }, [pathname, key]);

    //for AMT final
    // useEffect(() => {
    //     setPid('');
    //     setError('');
    //     if (pidRef.current) pidRef.current.focus();
    // }, [pathname, key]);

    // useEffect(() => {
    //     if (isMTurk) return;
    //
    //     const screeningOk = localStorage.getItem('screening_ok') === '1';
    //     const consentOk = localStorage.getItem('consent_ok') === '1';
    //
    //     if (!screeningOk || !consentOk) {
    //         const targetInterface =
    //             modeParam || (isAnnotate ? 'annotate' : 'write');
    //         navigate(`/screening?interface=${targetInterface}`);
    //     }
    // }, [isMTurk, modeParam, isAnnotate, navigate]);
    //for AMT final

    useEffect(() => {
        setError('');
        if (isMTurk) {
            setPid(workerId || '');
            return;
        }
        setPid('');
        if (pidRef.current) pidRef.current.focus();
    }, [pathname, key, isMTurk, workerId]);

    useEffect(() => {
        const screeningOk = localStorage.getItem('screening_ok') === '1';
        const consentOk = localStorage.getItem('consent_ok') === '1';

        // For AMT writer phase force write path
        const targetInterface = isAnnotate ? 'annotate' : 'write';

        if (!screeningOk || !consentOk) {
            const sp2 = new URLSearchParams(search || '');
            sp2.set('interface', targetInterface);
            navigate({ pathname: '/screening', search: `?${sp2.toString()}` });
        }
    }, [search, isAnnotate, navigate]);

    const handleBack = () => navigate('/');

    // const handleNewUser = () => {
    //     if (isAnnotate) {
    //         navigate('/register-evaluator?mode=annotate&interface=annotate');
    //     } else {
    //         navigate('/register-creator?mode=write&interface=write');
    //     }
    // };
    const handleNewUser = () => {
        const sp = new URLSearchParams(search || '');
        sp.set('interface', isAnnotate ? 'annotate' : 'write');
        navigate({
            pathname: '/screening',
            search: `?${sp.toString()}`,
        });
    };


    const handleReturningUser = () => {
        setShowPidForm(true);
        setTimeout(() => {
            if (pidRef.current) {
                pidRef.current.focus();
            }
        }, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // 1) If this came from AMT and it's still preview, stop here.
        if (isMTurk && isPreview) {
            setError('Please click “Accept HIT” in MTurk to begin (preview is read-only).');
            return;
        }
        // 2) If AMT (accepted), force pid=workerId and fetch assigned scenario from backend
        // if (isMTurk) {
        //     const effectivePid = workerId; // pid = workerId (as requested)
        //     try {
        //         const url = new URL('/api/scenario', window.location.origin);
        //         url.searchParams.set('pid', effectivePid);
        //         url.searchParams.set('assignmentId', assignmentId);
        //         url.searchParams.set('workerId', workerId);
        //         const r = await fetch(url.toString());
        //         if (!r.ok) throw new Error('Scenario lookup failed');
        //         const { scenario } = await r.json();
        //
        //         // Carry MTurk params forward so TaggingPage can show Finish-on-MTurk (if/when you use it)
        //         const next = new URL('/write-poem', window.location.origin);
        //         next.searchParams.set('interface', 'write');
        //         next.searchParams.set('pid', effectivePid);
        //         next.searchParams.set('scenario', scenario);
        //         next.searchParams.set('lock', '1');
        //         if (assignmentId) next.searchParams.set('assignmentId', assignmentId);
        //         const hitId = sp.get('hitId'); const turkSubmitTo = sp.get('turkSubmitTo');
        //         if (hitId) next.searchParams.set('hitId', hitId);
        //         if (turkSubmitTo) next.searchParams.set('turkSubmitTo', turkSubmitTo);
        //         window.location.replace(next.toString());
        //         return;
        //     } catch (e) {
        //         setError('Unable to assign a scenario right now. Please try again in a minute.');
        //         return;
        //     }
        // }

        const trimmed = pid.trim();

        if (!trimmed) {
            setError('Please enter your PID.');
            return;
        }

        setError('');

        try {
            const sessionToken = getSessionToken();

            const res = await fetch('/api/participants/lookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    pid: trimmed,
                    session_token: sessionToken,
                }),
            });

            const data = await res.json().catch(() => null);


            if (!res.ok || !data || !data.success) {
                if (data && data.already_completed) {
                    setError(data.message || 'You have already completed this study. Thank you!');
                    return;
                }
                setError((data && data.error) || 'PID not valid.');
                return;
            }
            // data: { success, pid, mode, scenario }
            const modeFromServer = data.mode || 'write'; // 'write' or 'annotate'
            const scenario = data.scenario || null;

            // Enforce that the PID type matches the gate the user chose
            if (isAnnotate && modeFromServer === 'write') {
                setError(
                    'This participant ID is not registered as an evaluator. '
                );
                return;
            }

            if (!isAnnotate && modeFromServer === 'annotate') {
                setError(
                    'This participant ID is registered as a creator. '
                );
                return;
            }

            // Save PID
            localStorage.setItem('pid', trimmed);

            // --- WRITE / CREATOR FLOW ---
            if (modeFromServer === 'write') {
                const effectiveScenario = scenario || 'human-only';

                localStorage.setItem('scenario', effectiveScenario);
                localStorage.setItem('scenarioLocked', 'true');
                sessionStorage.removeItem('poemEditorState'); // avoid stale restore

                // Preserve your MTurk params
                const next = new URLSearchParams();
                next.set('interface', 'write');
                next.set('pid', trimmed);
                next.set('scenario', effectiveScenario);
                next.set('lock', '1');
                if (assignmentId) next.set('assignmentId', assignmentId);
                if (hitId)        next.set('hitId', hitId);
                if (turkSubmitTo) next.set('turkSubmitTo', turkSubmitTo);

                navigate({ pathname: '/write-poem', search: `?${next.toString()}` });

                // --- ANNOTATE / EVALUATOR FLOW ---
            } else {
                localStorage.removeItem('scenario');
                localStorage.removeItem('scenarioLocked');

                const next = new URLSearchParams();
                next.set('interface', 'annotate');
                next.set('pid', trimmed);

                navigate({
                    pathname: '/poems',
                    search: `?${next.toString()}`
                });
            }

        } catch (err) {
            console.error(err);
            setError('Server error. Try again.');
        }
    };


    const title = isAnnotate
        ? 'Annotate Poems'
        : 'Write a Poem';

    // const description = isAnnotate
    //     ? 'Choose whether you are a new evaluator or returning with an existing participant ID.'
    //     : 'Choose whether you are a new creator or returning with an existing participant ID.';

    const description = isAnnotate
        ? 'Click below to begin.'
        : 'Click below to begin.';

    return (
        <div className="gate-wrapper">
            <button className="back-button" onClick={handleBack}>
                ← Back to Main Menu
            </button>
            {!isMTurk && (
            <div className="gate-card">
                <h1 className="gate-title">{title}</h1>
                <p className="gate-subtitle">{description}</p>

                {/* New vs Returning choice */}
                <div className="gate-choice-row">
                    <button
                        type="button"
                        className="gate-choice-button gate-choice-primary"
                        onClick={handleNewUser}
                    >
                        Registration form
                    </button>

                    <button
                        type="button"
                        className="gate-choice-button gate-choice-secondary"
                        onClick={handleReturningUser}
                        style={{display:'none'}} //temp for AMTurk
                    >
                        I already have a participant ID
                    </button>
                </div>

                {/* Returning user PID form */}
                {showPidForm && (
                    <form className="gate-form" onSubmit={handleSubmit}>
                        <label className="gate-label">
                            Enter your participant ID starting with "P_"
                        </label>
                        <input
                            ref={pidRef}
                            type="text"
                            className="gate-input"
                            value={pid}
                            onChange={(e) => setPid(e.target.value)}
                        />
                        <button
                            type="submit"
                            className="gate-cta"
                            disabled={!pid.trim()}
                            title={!pid.trim() ? 'Enter a PID to continue' : 'Continue'}
                        >
                            Enter
                        </button>
                        {error && <div className="gate-error">{error}</div>}
                    </form>
                )}
            </div>
                )}
            {isMTurk && (
                <div className="amt-notice">
                    You’re signing in via MTurk. Your Participant ID is your Worker ID.
                </div>
            )}
        </div>
    );
}

export default ParticipantGate;